import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Token storage helper — sessionStorage (clears on tab close) mitigates persistent
// XSS theft compared to localStorage. Primary auth path is the httpOnly cookie
// set by /api/auth/login; this is a fallback for browsers that reject the cookie
// due to the CORS allow_credentials + allow_origins='*' combination.
const TOKEN_KEY = "svn_token";
export const tokenStore = {
  get: () => {
    try { return sessionStorage.getItem(TOKEN_KEY); } catch { return null; }
  },
  set: (v) => {
    try { sessionStorage.setItem(TOKEN_KEY, v); } catch (e) { console.warn("token store unavailable", e); }
  },
  clear: () => {
    try { sessionStorage.removeItem(TOKEN_KEY); } catch {}
    // Also clear any legacy localStorage value left behind
    try { localStorage.removeItem(TOKEN_KEY); } catch {}
  },
};

// Attach token as a fallback (when cookies are blocked)
api.interceptors.request.use((config) => {
  const token = tokenStore.get();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
